export class DataCacheObject {
    name: string;
    cacheTime: Date;
    expireTime: Date;
    content: string;
}
